<template>
	<div class="margin-left">
		<div class="cont bg-white">
			<div class="bg-white margin-lr dvly padding-tb">
				<div class="flex align-center justify-center">
					<div class="round nocheck check"></div>
					<div class="noxian"></div>
					<div class="round nocheck" :class="is_real > 0?'check':''"></div>
					<div class="noxian"></div>
					<div class="round nocheck " :class="is_real == 2?'check':is_real == 3?'noguo':''"></div>
				</div>
				<div class="flex justify-between" style="padding-left: 60rpx;padding-right: 60rpx;width: 545px;margin: 21px auto;">
					<div class="text-sm text-666">上传证件</div>
					<div class="text-sm text-666">信息审核</div>
					
					<div class="text-sm text-666" v-if="is_real == 3">审核不过</div>
					<div class="text-sm text-666" v-else>审核通过</div>
				</div>
			</div>
			<div class="flex align-center justify-around matop50">
				<el-upload
				  class="avatar-uploader"
				   v-if="is_real == 0||is_real == 3"
				  action="https://manage.ciiply.com/api/pc/user/upFile"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="imageUrl" :src="imageUrl" class="portrait">
				  <div v-else>
				  	<img class="portrait" src="../../../assets/img/attestation/portrait.png" >
				  	<p>上传身份证人像面</p>
				  </div>
				</el-upload>
				<div v-else class="text-left"><img :src="imageUrl" class="portrait"></div>
				<el-upload
				  class="avatar-uploader"
				  action="https://manage.ciiply.com/api/pc/user/upFile"
				   v-if="is_real == 0||is_real == 3"
				  :show-file-list="false"
				  :on-success="handleSuccess"
				  :before-upload="beforeUpload">
				  <img v-if="idimageUrl" :src="idimageUrl" class="portrait">
				  <div v-else>
				  	<img class="portrait" src="../../../assets/img/attestation/emblem.png" >
				  	<p>上传身份证国徽面</p>
				  </div>
				</el-upload>
				<div v-else class="text-left"><img :src="idimageUrl" class="portrait"></div>
				
			</div>
			<p class="plan" v-if="is_real == 0" @click="fect('idnumber')">没带身份证？<span class="text-theme">直接身份证号认证</span></p>
			<p class="plan text-theme" v-if="is_real == 2">当前实名信息已审核通过</p>
			<div class="btns text-white" @click="sub" v-if="is_real == 0||is_real == 3">确认提交</div>
			<p class="margin-top">如有疑问请联系平台客服：400-212-22</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				is_real: 0,//0未申请，1是申请中，2是通过，3驳回
				imageUrl:'',//上传身份证人像面
				idimageUrl:'',//上传身份证国徽面
			}
		},
		created() {
			this.getReal()
		},
		methods: {
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type){
				let typeq = {
					type:type,
					typeone:''
				}
				this.$emit('gettype',typeq)
			},
			/**
			 * 上传身份证人像面
			 * */
			handleAvatarSuccess(file){
				this.imageUrl = file.data.url;
			},
			beforeAvatarUpload(){},
			/**
			 * 上传身份证国徽面
			 * */
			handleSuccess(file){
				this.idimageUrl = file.data.url;
			},
			beforeUpload(){},
			/**
			 * 确认提交
			 * */
			sub(){
				this.ajax('post', '/api/pc/userReal/certification', {
					zimg:this.imageUrl,
					fimg:this.idimageUrl,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.getReal()
						this.$message('提交成功');
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 获取实名进度
			 * */
			getReal(){
				this.ajax('get', '/api/pc/userReal/getReal', {
					type:1,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.imageUrl = res.data.zimg
						this.idimageUrl = res.data.fimg
						this.is_real = res.data.is_real	
					}else{
						this.$message(res.msg);
					}
				})
			},
			gonum(){
				
			}
		}
	}
</script>

<style scoped lang="less">
	.cont{
		width:920px;
		padding-top: 80px;
		padding-bottom: 80px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
	
	.matop50{
		margin-top: 50px;
	}
	.plan{
		margin-top: 100px;
		margin-bottom:50px;
	}
	.portrait{
		width: 302px;
		height: 194px;
	}
	.btns{
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 30px;
		margin: 40px auto 40px;
	}
	// 步骤器
	.nocheck{
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: rgba(11, 131, 124, 0.2);
	}
	.check{
		position: relative;
		&::after{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 13px;
			height: 13px;
			border-radius: 50%;
			background: rgba(11, 131, 124,1);
			content: '';
		}
	}
	.noguo{
		position: relative;
		background: rgba(242, 16, 64, 0.2) !important;
		&::after{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 13px;
			height: 13px;
			border-radius: 50%;
			background: rgba(242, 16, 64, 1);
			content: '';
		}
	}
	.noxian{
		width: 209px;
		height: 2px;
		background: rgba(11, 131, 124, 0.2);
	}
	//步骤器
</style>



// WEBPACK FOOTER //
// src/components/my/attestation/idcard.vue